






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Quote } from '@/modules/Quote/interfaces/quote'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class QuoteDetailAdditional extends Vue {
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
}
